export default function disableInputIfReadOnly(formField, isEdit) {
    if (formField?.conditionalReadOnly) {
        const isReadOnlyEdit = isEdit && formField?.conditionalReadOnly?.readOnlyOnEdit;
        const isReadOnlyCreate = !isEdit && formField?.conditionalReadOnly?.readOnlyOnCreate;
        const isReadOnly = isReadOnlyEdit || isReadOnlyCreate;
        // eslint-disable-next-line no-param-reassign
        formField.props = { ...formField.props, disabled: isReadOnly };
    }
}
